import { ITheme } from "../../utils/theme"

export const descRowStyle = {
  background: (theme: ITheme) => theme.palette.blue[300],
  p: 1,
  fontWeight: 'bold',
}

export const slipsRowStyle = (theme: ITheme) => ({
  background: theme.palette.blue[100],
  '& .MuiTableCell-root': {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  '& .MuiTableCell-root:last-of-type': {
    borderRight: 'none',
  }
})

export const countRowStyle = (theme: ITheme) => ({
  background: 'white',
  p: 1,
  mb: 3,
  color: theme.palette.blue.A300,
  fontWeight: 'bold',
})

export const noSlipsStyle = {
  color: (theme: ITheme) => theme.palette.red.A700,
  pt: 1,
  pb: 1
}

export const slipWrapStyle = {
  mr: 1,
  display: 'flex',
  alignItems: 'center'
}

export const slipInfoWrapStyle = {
  position: 'relative',
  mb: 1,
  minWidth: { xs: '115px', sm: '180px' }
}